
import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from 'vue-router';
export default {
     name:"AdminRateEdit",
 setup() {
    const data  =reactive({
        distance_type:'',
        per_unit_price:'',
        base_price:'',
        base_unit:'',
        is_base_rate:'',
        is_reference_rate:'',
        is_advance_rate:'',
        city_id:'',
        second_package_price:'',
        third_package_price:'',
        fourth_package_price:'',
        user_id:0,
       

    });
   
      const router = useRouter();
      const route = useRoute();
     const cities =ref([]);

    onMounted(async ()=>{
      const  citiesResponse = await axios.get('cities/all/list');
      cities.value = citiesResponse.data;
      if(route.params.id){
        var paramid = route.params.id;
        data.user_id =  Number(paramid);
      }
     

    });

const submit =async ()=>{

await axios.post(`/rates`,data);

await router.push('/rates');
}


    return {
        data,
        cities,
      submit
    };
  },
};
